<template>
  <div>
    <div class="padding">
      <div class="text-gray">最多设置{{ maxCount }}个标签，总字数不能超过30个字符。</div>
      <van-button v-if="$hasFeature('custom_47')||$hasFeature('gaming_module')" type="default" @click="openActionSheet">可选择标签</van-button>
      <van-cell-group class="margin-top">
        <van-field v-for="( index) in maxCount" v-model="tags[index-1]" :placeholder="`标签${index}`" :key="index"
                   maxlength="20" />
      </van-cell-group>
      <van-action-sheet v-model="actionSheetVisible" :title="`可选择标签（${Math.min(maxCount - diyCount,3)}）`" :closeable="false">
        <van-checkbox-group v-model="result">
          <van-cell-group>
            <van-cell
                v-for="(tag, index) in optionTagList"
                clickable
                :key="index"
                :title="tag"
                @click="toggle(index)"
            >
              <template #right-icon>
                <van-checkbox :name="tag" ref="checkboxes" shape="square" :disabled="!result.includes(tag) && (result.length + diyCount >=maxCount || result.length >= 3)"  />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <div style="display: flex;justify-content: space-around;margin: 20px 0">
          <van-button @click="actionSheetVisible = false">取消</van-button>
          <van-button type="info" @click="confirmSelect">确定</van-button>
        </div>
      </van-action-sheet>
      <div class="text-center margin-tb">
        <van-button type="primary" size="large" @click="submit">保存</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Cell, CellGroup, Checkbox, CheckboxGroup, Button, Toast, Dialog, Field, Icon, ActionSheet} from 'vant';
import {getClerk, listItemTag, updateTags, getGamingClerkInfo} from '@/api/clerk/clerk'
import _ from 'lodash'
Vue.use(Cell)
    .use(CellGroup)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Button)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Icon)
    .use(ActionSheet)

export default {
  name: 'updateTags',
  computed:{
    diyCount(){
      let tags = _.filter(this.tags,(elem)=>{
        return elem && elem.trim()
      })
      return  tags.length - _.intersection(tags,this.optionTagList).length
    }
  },
  data() {
    return {
      itemType: this.$route.query.itemType,
      tags: [],
      maxCount: 5,
      actionSheetVisible: false,
      optionTagList: [],
      result: []
    }
  },
  methods: {
    openActionSheet(){
      this.result = []
      this.result = Array.from(_.intersection(this.optionTagList,this.tags))
      this.actionSheetVisible=true
    },
    confirmSelect(){
      this.tags = _.filter(this.tags,(elem)=>{
        return elem && elem.trim() && (!this.optionTagList.includes(elem) || this.result.includes(elem))
      })
      this.tags.push(...Array.from(new Set(this.result).difference(new Set(this.tags))))
      this.actionSheetVisible = false
    },
    toggle(index) {
      if(!this.$refs.checkboxes[index].disabled){
        this.$refs.checkboxes[index].toggle();
      }
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      if(this.itemType === 'gaming'){
        getGamingClerkInfo().then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            if(data.clerk.gameTags){
              let tags = data.clerk.gameTags
              for (let i = 0; i < tags.length; i++) {
                this.$set(this.tags, i, tags[i])
              }
            }
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      }else{
        getClerk().then(res => {
          Toast.clear()
          const data = res.data
          if (data.code == 0) {
            let tags = data.clerk.tags
            for (let i = 0; i < tags.length; i++) {
              this.$set(this.tags, i, tags[i])
            }
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      }
    },
    submit() {
      Toast.loading({
        mask: true,
        message: '请稍候...'
      })

      let tagList = []
      let wordCount = 0
      for (const tag of this.tags) {
        if (tag != null && tag.trim() != '') {
          tagList.push(tag.trim())
          wordCount += tag.length
        }
      }

      if (wordCount > 30) {
        return Toast('标签总字数不能超过30个字');
      }
      if(_.intersection(this.optionTagList,tagList).size > 3){
        return Toast('选择标签不可超过3个')
      }

      updateTags(JSON.stringify(tagList),
          this.itemType === 'gaming' ? this.itemType : null).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: '提交成功'
          }).then(() => {
            this.$router.back(-1)
          })
        } else {
          this.loadData()
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    },
    loadItemTag(){
      listItemTag().then(res=>{
        const data = res.data
        if(data.code===0){
          this.optionTagList = data.list
        }
      })
    }
  },
  mounted() {
    // for (let i = 0; i < this.maxCount; i++) {
    //   this.tags.push(null)
    // }
    if(this.$hasFeature('custom_47')){
      this.loadItemTag();
    }
    this.loadData()
  }
}
</script>

<style lang="less" scoped>


</style>
